import { createContext } from 'react';
import { checkboxVariants, ICheckboxVariants } from './checkbox.variants';

export type CheckboxContextProps = {
  variant?: keyof typeof checkboxVariants | (string & {});
  variants?: ICheckboxVariants;
};

export const CheckboxContext = createContext<CheckboxContextProps | null>(null);
